import { SideSheet, SideSheetClose, SideSheetHeader, SideSheetSubHeader } from '@bechtel/gds';
import { t } from '@lingui/macro';
import { FC } from 'react';
import { WeldSubHeader } from '~/components/molecules';
import { ClaimReclaimWeld } from '../claim-reclaim-weld';
import { WeldClaimProps } from './types';

export const WeldClaim: FC<WeldClaimProps> = ({ isClaimAndApprove, weld, close, isReclaim, refetchQueries }) => {
  return (
    <SideSheet visible onDismiss={close} data-testid="claim-weld-sidesheet">
      <SideSheetHeader title={isReclaim ? t`Reclaim Weld` : t`Claim Weld`}>
        <SideSheetClose onClick={close}></SideSheetClose>
      </SideSheetHeader>
      <SideSheetSubHeader>
        <WeldSubHeader
          tag={weld?.tag}
          pipeMaterial={weld?.pipeMaterial ? weld.pipeMaterial : ''}
          pipeDiameter={weld?.pipeDiameter ? weld.pipeDiameter : 0}
        />
      </SideSheetSubHeader>
      <ClaimReclaimWeld
        weldCommodity={weld}
        isReclaim={isReclaim}
        isClaimAndApprove={isClaimAndApprove}
        close={close}
        refetchQueries={refetchQueries}
      />
    </SideSheet>
  );
};
